module.exports = __webpack_public_path__ + "img/instruction3.f973da22.jpg";